/* src/app/admin-dashboard/site-system/category/category-detail-popup/category-detail-popup.css */
.red {
  color: white;
  background: red;
}
.green {
  color: white;
  background: green;
}
.popup-header {
  background-color: var(--custom-color);
  color: white;
  height: 90px;
  width: "auto";
  font-size: 30px;
  padding: 30px;
}
::ng-deep .mat-mdc-dialog-container {
  padding-top: 0 !important;
  border-radius: 15px;
}
::ng-deep user-detail-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
::ng-deep .mat-mdc-dialog-actions {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
::ng-deep .mat-mdc-dialog-title {
  margin-top: 15px !important;
}
.edit {
  float: right;
  cursor: pointer;
  right: 0 !important;
  top: 0 !important;
}
.title {
  float: left;
}
.example-chip-list {
  width: 80%;
}
/*# sourceMappingURL=category-detail-popup.css.map */
